import isEmpty from '../is-empty';

/**
 * Retrieves the value of a specific parameter from a given URL
 *
 * @param {String} url       A string representing the URL to be searched for the parameter value (default is an empty string)
 * @param {String} parameter A string representing the key of the parameter to be retrieved (default is an empty string)
 * @return {String}           The parameter value
 */
const getURLParameter = ( url = '', parameter = '' ) => {
	// If the URL is empty, use the site URL
	if ( isEmpty( url ) ) {
		url = window.location.href;
	}

	// Convert it to an URL object
	url = new URL( url );

	// Get parameter
	return url.searchParams.get( parameter );
};

export default getURLParameter;
